import { render, staticRenderFns } from "./ServiceTasksCreatePage.vue?vue&type=template&id=7cf43d0c&"
import script from "./ServiceTasksCreatePage.vue?vue&type=script&lang=ts&"
export * from "./ServiceTasksCreatePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports